import Vue from 'vue'
import Antd from 'ant-design-vue';

// import './update'

import App from './App'
import 'ant-design-vue/dist/antd.css';
import './css/index.css';//覆盖的antd样式
import router from './router'
import store from './store'
store.commit("setUserinfo", {}); //清空用户基本信息 为了再主动走一次用户信息接口 确保token是否过期
store.commit("setProjectId", ""); //清空管理员的header里project_id
import './icons'
import './css/common.css';
import permission from '@/directive/permission'
Vue.use(permission)

!(function (t) {
  function e() {
    var e = this || self;
    (e.globalThis = e), delete t.prototype._T_;
  }
  "object" != typeof globalThis &&
    (this
      ? e()
      : (t.defineProperty(t.prototype, "_T_", {
        configurable: !0,
        get: e,
      }),
        _T_));
})(Object);

import 'viewerjs/dist/viewer.css'
import VueViewer from 'v-viewer'
VueViewer.setDefaults({
  title: false,
})
Vue.use(VueViewer)

// var log = require('electron-log');
// log.error("error");
// log.warn("warn");
// log.info("info");
// log.verbose("verbose");
// log.debug("debug");
// log.silly("silly");

import Card from './components/Card/index'// svg组件
// register globally
Vue.component('Card', Card)

// import './HardwareSDK' //硬件服务
Vue.config.productionTip = false



Vue.use(Antd);

/* eslint-disable no-new */
new Vue({
  // components: { App },
  // router,
  // store,
  // template: '<App/>'
  router,
  store,
  render: h => h(App)
}).$mount('#app')